/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import IcdDetails from './icd-details';
import IcdDetailsDetail from './icd-details-detail';
import IcdDetailsUpdate from './icd-details-update';
import IcdDetailsDeleteDialog from './icd-details-delete-dialog';

const IcdDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<IcdDetails />} />
    <Route path="new" element={<IcdDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<IcdDetailsDetail />} />
      <Route path="edit" element={<IcdDetailsUpdate />} />
      <Route path="delete" element={<IcdDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default IcdDetailsRoutes;
